// extracted by mini-css-extract-plugin
export default {"wrap":"BaechaList2Table_wrap__ChStK","cursorPointer":"BaechaList2Table_cursorPointer__f7b+T","address":"BaechaList2Table_address__e7EJZ","oddRow":"BaechaList2Table_oddRow__-K6lY"};